<template>
  <!-- ##关于纳星 -->
  <div id="about-nx">
    <page-banner title="关于金界" content="专注计算机与校园领域的研发"></page-banner>
    <div class="breadcrumb-nav">
      <v-breadcrumb separator="/" separatorClass="fa fa-angle-right">
        <v-breadcrumb-item to="/">首页</v-breadcrumb-item>
        <v-breadcrumb-item to="/about">关于</v-breadcrumb-item>
      </v-breadcrumb>
    </div>
    <div class="company-introduction">
      <p class="content-title">公司简介</p>
      <div class="introduction-content" v-html="contInfo.info.content">
        {{contInfo.info.content}}
        <!-- <p></p> -->
        <!-- <p>广州市金界电子设备有限公司十八年专注计算机与校园领域的研发，是校园智慧互联网、物联网、校园大数据、云计算、校园人工智能等解决方案及其产品制造集成服务商，系统产品遍及校园安全管理、师生健康、智能校园、智慧教室，深入现代学校、未来学校的探究，把校园万物智能互联，让校园人工智能无处不在，方案浸透校园的每一项目。有自主专利知识产权及著作权，有十八年产品使用效果及质量验证。系统产品突显安全、实用、标准、经济，具先进前瞻性，切实解决学校实际需求。专研创新教育装备走在行业的前列，系统产品适合全国大专中小学及幼儿园示范应用。促进学校教育现代化，信息智慧化。</p>
        <p>近年，公司继续走进未来学校教育装备的研究，深挖开发更多为学校教育走向领航者的系统产品，携手学校合作伙伴与时俱进。</p> -->
      </div>
    </div>
  </div>
</template>
<style scoped>
#about-nx {
  width: 100%;
  min-height: 800px;
}
.company-introduction {
  width: 1000px;
  height: 400px;
  margin: 0 auto;
}
.introduction-content {
  padding-top: 30px;
  width: 91%;
  margin: 0 auto;
  color: rgb(102, 102, 102);
  font-size: 16px;
}
.introduction-content >>> p {
  text-indent: 2em;
  margin-top: 5px;
}
</style>
<script>
export default {
  name: "about-nx",
  data() {
    return {
      contInfo: {
        info: {
          content: "<p>关于金界</p>"
        }
      }
    };
  },
  mounted() {
    var self = this;
    $.ajax({
      url: "/aboutmanage.php",
      type: "get",
      data: null,
      headers: {
        "Content-Type": "application/json"
      },
      success: function(data, textStatus, jqXHR) {
        var data = JSON.parse(data)[0];
        data.info = JSON.parse(data.info);
        console.log(data);
        self.contInfo = data;
        
      },
      error(jqXHR, status, errormsg) {}
    })
  }
};
</script>








// WEBPACK FOOTER //
// src/components/about-content.vue